import React from 'react';
import { Link} from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import DatePicker from 'react-datepicker';
import Tooltip from 'rc-tooltip';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import 'react-datepicker/dist/react-datepicker.css';
import Joi from 'joi';
import Form from '../../common/form.jsx';
import withRouter from "../../common/withRouter.jsx";
import http from '../../services/httpService';
import auth from '../../services/authservice';
import {saveOperator,getOperator,getOperators} from './../../services/operators';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from 'react-redux';
import { getCurrentUser, loadCurrentUser } from '../../store/users';

const Handle = Slider.Handle;
const apiUrl = process.env.REACT_APP_API_URL;

class Operator extends Form {
	constructor(props) {
		super(props);
	
		this.state = {
			countries: [],
			data: {
				username: '',
				password: '',
				email: '',
				firstName: '',
				lastName: '',
				initials: '',
				gender: '',
				dateBirth: new Date(),
				prefix: '',
				address1: '',
				address2: '',
				address3: '',
				zip: '',
				city: '',
				state: '',
				country: '',
				longitude: '',
				latitude: '',
				department: '',
				phone: '',
				mobile: '',
				skype: '',
				mood: '',
				status: '',
			},
			imageSrc: null,
			errors: {}
		}

		this.prefixOptions = [
			{ value: 'Mr', label: 'Mr.' },
			{ value: 'Mrs', label: 'Mrs.' },
			{ value: 'Mss', label: 'Mss.' },
			{ value: 'Ms', label: 'Ms.' },
			{ value: 'Prof', label: 'Prof.' },
			{ value: 'Dr', label: 'Dr.' }
		];

		this.genderOptions = [
			{ value: 'Female', label: 'Female' },
			{ value: 'Male', label: 'Male' },
			{ value: 'Other', label: 'Other' }
		];

		this.statusOptions = [
			{value: 'active', label: 'Active'},
			{value: 'banned', label: 'Banned'},
			{value: 'deleted', label: 'Deleted'},
			{value: 'inactive', label: 'Inactive'},
			{value: 'archived', label: 'Archived'}
		];

		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onChangeImgHandler = this.onChangeImgHandler.bind(this);
	}

	async populateCountries() {
		const { data: countries } = await http.get(apiUrl+"/countries");
		this.setState({ countries: countries });
		this.selectCountries = this.state.countries.map((country) => ({ _id: country._id,label: country.name, value: country.name }));
	}

	async populateGenders(){
		this.genderoptions = this.genderOptions.map(option => (
			<option key={option.label} value={option.value}>
				{option.value}
			</option>
		));
	}

	async populatePrefix(){
		this.prefixoptions = this.prefixOptions.map(option => (
			<option key={option.label} value={option.value}>
				{option.value}
			</option>
		));
	}

	async populateStatus(){
		this.statusoptions = this.statusOptions.map(option => (
			<option key={option.label} value={option.value}>
				{option.value}
			</option>
		));
	}

	async populateUser() { 
		try {
			const userId = this.props.params?.id;
			
			if (userId === "new" || !userId) {
				return;
			}

			// Get the full data from the list endpoint to have all nested information
			const { data: allOperators } = await getOperators();
			
			// Find the specific operator by ID
			const operatorRecord = allOperators.find(op => op._id === userId);
			
			if (!operatorRecord) {
				throw new Error("Operator not found");
			}
			
			// Extract data from the nested structure
			const operator = operatorRecord.operators || {};
			const companyInfo = operatorRecord.companyInfo || {};
			
			const processedOperator = {
				_id: operatorRecord._id,
				username: operator.username || '',
				email: operator.email || '',
				firstName: operator.contactName?.first || '',
				lastName: operator.contactName?.last || '',
				initials: operator.contactName?.initials || '',
				prefix: operator.prefix || '',
				gender: operator.gender || '',
				dateBirth: operator.dateBirth || new Date(),
				address1: operator.Address?.address1 || '',
				address2: operator.Address?.address2 || '',
				address3: operator.Address?.address3 || '',
				zip: operator.Address?.zip || '',
				city: operator.Address?.city || '',
				state: operator.Address?.state || '',
				country: operator.Address?.country || '',
		//		longitude: operator.Address?.location?.coordinates?.[0] || 0, latitude: operator.Address?.location?.coordinates?.[1] || 0,
				department: companyInfo.department || '',
				phone: operator.phones?.phone || '',
				mobile: operator.phones?.mobile || '',
				skype: operator.phones?.skype || '',
				mood: operator.mood || '',
				status: operatorRecord.status || '',
			};

			const mappedData = this.mapToViewModel(processedOperator);
			this.setState({ data: mappedData });
		} catch (ex) {
			if (ex.response && ex.response.status === 404) {
				if (this.props.navigate) {
					this.props.navigate("/error", { replace: true });
				}
			} else {
				toast.error(`Error loading operator data: ${ex.message || 'Unknown error'}`);
			}
		}
	}


	async componentDidMount() {
		// Load current user for company role detection
		const user = auth.getProfile();
		if (user) {
			await this.props.loadCurrentUser(user._id);
		}
		
		await this.populatePrefix();
		await this.populateGenders();
		await this.populateCountries();
		await this.populateStatus();
		await this.populateUser();
	// this.getCurrentLocation();
	}


schema = Joi.object({
		username: Joi.string()
			.alphanum()
			.min(1)
			.max(30)
			.required(),
		password: Joi.string()
			.pattern(new RegExp('^[a-zA-Z0-9]{3,30}$'))
			.optional()
			.allow(''),
		email: Joi.string().email({ tlds: { allow: false } }).optional().allow(''),
		firstName: Joi.string().required(),
		lastName: Joi.string().required(),
		initials: Joi.any().optional().allow(''),
		gender: Joi.string().optional().allow(''),
		dateBirth: Joi.date().optional(),
		prefix: Joi.string().optional().allow(''),
		address1: Joi.string().optional().allow(''),
		address2: Joi.string().optional().allow(''),
		address3: Joi.string().optional().allow(''),
		zip: Joi.string().optional().allow(''),
		city: Joi.string().optional().allow(''),
		state: Joi.string().optional().allow(''),
		country: Joi.string().optional().allow(''),
//		longitude: Joi.number().optional(), latitude: Joi.number().optional(),
		department: Joi.string().optional().allow(''),
		phone: Joi.string().optional().allow(''),
		mobile: Joi.string().optional().allow(''),
		skype: Joi.string().optional().allow(''),
		mood: Joi.string().optional().allow(''),
		status: Joi.string().required(),
		imageSrc: Joi.any().optional().allow('') // Add imageSrc validation
	});


	handleDobChange = (e) => {
		const data = { ...this.state.data };
		data['dateBirth'] = e;
		this.setState({ data });
	};
	
	onChangeImgHandler = (event) => {
		this.setState({ imageSrc: event.target.files[0] });
	};

	doSubmit = async (user) => {
		if (!process.env.REACT_APP_API_URL) {
			toast.error("Configuration error: API URL not set");
			return;
		}
		
		const operationType = this.isEditing() ? "updating" : "creating";
		
	    try{
			const submitData = { ...this.state.data };
			
			// Get current user and add businessNo if role is Company
			const currentUser = this.props.currentUser;
			
			// Check if role name is "Company"
			const isCompanyRole = (currentUser?.roleName === "Company") || 
								 (currentUser?.role === "Company") ||
								 (currentUser?.role?.name === "Company");
			
			if (currentUser && isCompanyRole) {
				// accountNo is already the ID string, not an object with _id
				submitData.businessNo = currentUser?.accountNo;
			}
			
			// Don't send empty password on update
			if (this.isEditing() && (!submitData.password || submitData.password.trim() === '')) {
				delete submitData.password;
			}
			
			const result = await saveOperator(submitData, this.state.imageSrc);
			
			toast.success(`Operator ${operationType === "updating" ? "updated" : "created"} successfully!`);
			
			// Navigate back to operators list
			setTimeout(() => {
				if (this.props.navigate) {
					this.props.navigate("/user/operators");
				} else if (this.props.history) {
					this.props.history.push("/user/operators");
				}
			}, 1500);
		}catch(ex){
			console.error('Submit error:', ex);
			console.error('Error response:', ex.response);
			console.error('Error response data:', ex.response?.data);
			console.error('Error response status:', ex.response?.status);
			
			let userMessage = "";
			
			if (ex.code === 'ECONNABORTED') {
				userMessage = "Request timed out. Please try again.";
			} else if (!ex.response) {
				userMessage = "Cannot connect to server. Please check your internet connection.";
			} else if (ex.response?.status >= 500) {
				userMessage = `Server error (${ex.response.status}). Please try again later.`;
			} else if (ex.response?.status >= 400) {
				userMessage = ex.response?.data?.message || ex.response?.data || 'Validation error occurred.';
			} else {
				userMessage = `Unexpected error: ${ex.message}`;
			}
			
			toast.error(userMessage);
			
			if(ex.response && ex.response.status < 500){
				const errors = {...this.state.errors};
				let errorMessage = ex.response.data;
				let path = 'general';
				
				if (typeof errorMessage === 'string' && errorMessage.includes('"')) {
					path = errorMessage.split('"')[1] || 'general';
				} else if (typeof errorMessage === 'object' && errorMessage.message) {
					errorMessage = errorMessage.message;
				}
				
				errors[path] = errorMessage;
				this.setState({errors});
			}
		}
	};
	
	mapToViewModel(user) {
		const mapped = {
			_id: user._id,
			username: user.username || '',
			password: '', // Don't populate password for security
			email: user.email || '',
			firstName: user.firstName || '',
			lastName: user.lastName || '',
			initials: user.initials || '',
			gender: user.gender || '',
			dateBirth: user.dateBirth ? new Date(user.dateBirth) : new Date(),
			prefix: user.prefix || '',
			address1: user.address1 || '',
			address2: user.address2 || '',
			address3: user.address3 || '',
			zip: user.zip || '',
			city: user.city || '',
			state: user.state || '',
			country: user.country || '',
//			longitude: user.longitude !== undefined ? user.longitude : '', 	latitude: user.latitude !== undefined ? user.latitude : '',
			department: user.department || '',
			phone: user.phone || '',
			mobile: user.mobile || '',
			skype: user.skype || '',
			mood: user.mood || '',
			status: user.status || '',
			imageSrc: user.operators?.imageSrc || user.imageSrc || user.companies?.imageSrc || ''
		};
		
		return mapped;
	}

	isEditing = () => {
		const userId = this.props.params?.id;
		return userId && userId !== "new";
	}

	getPageTitle = () => {
		return this.isEditing() ? "Edit Operator" : "Add Operator";
	}

/*	getCurrentLocation = () => {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				(position) => {
					const data = { ...this.state.data };
					data.latitude = position.coords.latitude;
					data.longitude = position.coords.longitude;
					
					this.setState({ data });
				},
				(error) => {
					// Set default coordinates (example: New York City)
					const data = { ...this.state.data };
					data.latitude = 40.7128;
					data.longitude = -74.0060;
					
					this.setState({ data });
					
					// Show user-friendly error message
					const errors = { ...this.state.errors };
					switch(error.code) {
						case error.PERMISSION_DENIED:
							errors.location = "Location access denied. Using default coordinates.";
							break;
						case error.POSITION_UNAVAILABLE:
							errors.location = "Location information unavailable. Using default coordinates.";
							break;
						case error.TIMEOUT:
							errors.location = "Location request timed out. Using default coordinates.";
							break;
						default:
							errors.location = "An unknown error occurred while retrieving location.";
							break;
					}
					this.setState({ errors });
				},
				{
					enableHighAccuracy: true,
					timeout: 10000, // 10 seconds
					maximumAge: 300000 // 5 minutes
				}
			);
		} else {
			// Set default coordinates
			const data = { ...this.state.data };
			data.latitude = 40.7128;
			data.longitude = -74.0060;
			
			this.setState({ data });
			
			const errors = { ...this.state.errors };
			errors.location = "Geolocation not supported. Using default coordinates.";
			this.setState({ errors });
		}
	};  */

	render() {

		const { data, errors } = this.state;
		return (
			<React.Fragment>
				<ToastContainer 
					position="top-right"
					autoClose={5000}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
				/>
				<div>
					<ol className="breadcrumb float-xl-right">
						<li className="breadcrumb-item"><Link to="/user/operators">Operators</Link></li>
						<li className="breadcrumb-item active">{this.getPageTitle()}</li>
					</ol>
					<h1 className="page-header">
						{this.getPageTitle()} <small>Operator-registration-form</small>
					</h1>

					<div className="row">
						<div className="col-xl-10">
							<Panel>
								<PanelHeader>{this.getPageTitle()}</PanelHeader>
								<PanelBody className="panel-form">
									<form className="form-horizontal form-bordered" onSubmit={this.handleSubmit} >
 
										<div className="form-group row">
											<label className="col-lg-4 col-form-label" htmlFor="prefix" >Prefix</label>
											<div className="col-lg-8">
												<select name="prefix" id="prefix" value={data.prefix} onChange={this.handleChange} className="form-control" >
													<option value="">Select Prefix</option>
													{this.prefixoptions}
												</select>
											</div>
											{errors.prefix && (<div className="alert alert-danger">{errors.prefix}</div>)}
										</div>

										{this.renderInput("firstName","First Name","text","* Enter Firstname")}
										{this.renderInput("initials","Initials","text","Enter Initials")}
										{this.renderInput("lastName","Last Name","text","* Enter Lastname")}										
                                        					{this.renderInput("address1","Address 1","text","Enter address1")} 
										{this.renderInput("address2","Address 2","text","Enter address2")} 
										{this.renderInput("address3","Address 3","text","Enter address3")}
										{this.renderInput("zip","Zip code","text","Enter zipcode")} 
										{this.renderInput("city","City","text","Enter City")}
										{this.renderInput("state","State","text","Enter State")}
										{this.renderSelect("country","Country",	this.state.countries)}

										{this.renderInput("department","Department","text","Enter Department")}
										{this.renderInput("phone","Phone","text","Enter Phone")}
										{this.renderInput("mobile","Mobile","text","Enter Mobile")}
										{this.renderInput("skype","Skype","text","Enter Skype")}
										{this.renderInput("mood","Mood","text","Enter Mood")}
										
										<div className="form-group row">
											<label className="col-lg-4 col-form-label" htmlFor="gender" >Gender</label>
											<div className="col-lg-8">
												<select name="gender" id="gender" value={data.gender} onChange={this.handleChange} className="form-control" >
													<option value="">Select Gender</option>
													{this.genderoptions}
												</select>
											</div>
											{errors.gender && (<div className="alert alert-danger">{errors.gender}</div>)}
										</div>

										<div className="form-group row">
											<label className="col-lg-4 col-form-label" htmlFor="dateBirth" >Date of Birth</label>
											<div className="col-lg-8">
												<DatePicker
													onChange={this.handleDobChange}
													id={data.dateBirth}
													value={data.dateBirth}
													selected={data.dateBirth}
													inputProps={{ placeholder: "Datepicker" }}
													className="form-control"
												/>
												{errors.dateBirth && <div className="alert alert-danger">{errors.dateBirth}</div>}
											</div>
										</div>
										
										<div className="form-group row">
											<label className="col-lg-4 col-form-label" htmlFor="username">UserName</label>
											<div className="col-lg-8">
												<div className="row row-space-10">
													<input type="text" id="username" name="username" value={data.username}
														className="form-control m-b-5" placeholder="Enter username"
														onChange={this.handleChange}
														autoFocus />
													{errors.username && (
														<div className="alert alert-danger">
															{errors.username}
														</div>
													)}
												</div>
											</div>
										</div>

										{this.renderInput("email", "Email", "email", "Enter email")}
										{this.renderInput("password", "Password", "password", this.isEditing() ? "Leave blank to keep current password" : "Enter Password")}

										<div className="form-group row">
											<label className="col-lg-4 col-form-label" htmlFor="imageSrc">Avatar</label>
											<div className="col-lg-8">
												<div className="row row-space-10">
													<input type="file" id="imageSrc" name="imageSrc"
														className="form-control-file m-b-5"
														onChange={this.onChangeImgHandler}
														accept="image/*"
													/>
													{this.isEditing() && (
														<small className="form-text text-muted">
															Leave empty to keep current avatar
														</small>
													)}
													{errors.imageSrc && (
														<div className="alert alert-danger">
															{errors.imageSrc}
														</div>
													)}
												</div>
											</div>
										</div>

										<div className="form-group row">
											<label className="col-lg-4 col-form-label" htmlFor="status" >Select Status</label>
											<div className="col-lg-8">
												<select name="status" id="status" value={data.status} onChange={this.handleChange} className="form-control" >
													<option value="">Select Status</option>
													{this.statusoptions}
												</select>
											</div>
											{errors.status && (<div className="alert alert-danger">{errors.status}</div>)}
										</div>

										<div className="form-group row">
											<div className="col-lg-8">
												<button	type="submit" disabled={this.validate()} className="btn btn-primary width-65">Submit</button>
											</div>
										</div>
									</form>
								</PanelBody>
							</Panel>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	currentUser: getCurrentUser(state)
});

const mapDispatchToProps = (dispatch) => ({
	loadCurrentUser: (id) => dispatch(loadCurrentUser(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Operator));
